import AddPermission from "../../Components/Modals/AddPermission";
import Table from "../../Components/Table";
import { deletePermissionById, getPermission } from "../../Services/MasterService";

const Permission = () => {
  const columns = [
    {
      label: "Name",
      value: "name"
    }
  ];

  const renderAddModal = (openAddModal, setOpenAddModal) => {
    return (
      <AddPermission data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
    )
  };

  return (
    <Table
      api={getPermission}
      columns={columns}
      title={"Permission Master"}
      addModal={renderAddModal}
      showAddButton={true}
      showExportButton={true}
      deleteApi={deletePermissionById}
    />
  );
}

export default Permission;